import { FC, memo } from 'react'
import { Avatar as ChakraAvatar, AvatarProps } from '@chakra-ui/react'

import { DefaultAvatarIllustration } from 'components/illustrations'

type Props = AvatarProps & {
  src?: string
  size?: string
}

const Avatar: FC<Props> = ({ src, size, ...rest }) => {
  if (!src) return <DefaultAvatarIllustration size={size} />

  return <ChakraAvatar src={src} size={size} {...rest} />
}

export default memo(Avatar)
